/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it handle commas and quotes inside fields?`)
};

const es_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Gestiona comas y comillas dentro de campos?`)
};

const de_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werden Kommas und Anführungszeichen innerhalb von Feldern verarbeitet?`)
};

const nl_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerkt het komma's en aanhalingstekens in velden?`)
};

const fr_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère-t-il les virgules et les guillemets dans les champs ?`)
};

const it_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce virgole e virgolette all'interno dei campi?`)
};

const pt_br2_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele trata vírgulas e aspas dentro de campos?`)
};

const pt_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciona com vírgulas e aspas dentro dos campos?`)
};

const ja_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィールド内のコンマと引用符を処理できますか？`)
};

const zh_cj_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它能处理字段内的逗号和引号吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cj_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cj_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cj_faq1_q", locale)
	if (locale === "en") return en_cj_faq1_q(inputs)
	if (locale === "es") return es_cj_faq1_q(inputs)
	if (locale === "de") return de_cj_faq1_q(inputs)
	if (locale === "nl") return nl_cj_faq1_q(inputs)
	if (locale === "fr") return fr_cj_faq1_q(inputs)
	if (locale === "it") return it_cj_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_cj_faq1_q(inputs)
	if (locale === "pt") return pt_cj_faq1_q(inputs)
	if (locale === "ja") return ja_cj_faq1_q(inputs)
	return zh_cj_faq1_q(inputs)
};